$(document).ready(function () {
    if($("#collectorSearchField").length >0 ) {
        /**
         * Művész kereső autocomplete
         */
        $("#collectorSearchField").autocomplete({
            delay: 0,
            minLength: 2,
            source: function (request, response) {
                $.ajax({
                    url: "/ajaxRequest/collector/findByTerm",
                    dataType: "json",
                    data: {
                        term: request.term
                    },
                    success: function (resp) {
                        console.log(resp.data);
                        response(resp.data);
                    }
                });
            },
            select: function (event, ui) {
                location.href = ui.item.href;
            }
        });
    }
});
